
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutGrid extends _Ext.GridBase<BranchOutRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchOut'; }
        protected getDialogType() { return BranchOutDialog; }
        protected getIdProperty() { return BranchOutRow.idProperty; }
        protected getInsertPermission() { return BranchOutRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchOutRow.localTextPrefix; }
        protected getService() { return BranchOutService.baseUrl; } 
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {            
            var item = this.itemAt(row); 
            super.onClick(e, row, cell);            
        }
        protected addButtonClick() {
            
            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(44);


            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[44].AutoPosting;

            this.editItem(<BranchOutRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 44,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}